import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import { TABLET_WIDTH } from '../../constants/dims';
import imgPotential from '../../assets/img/potential.png';
import { withRouter } from 'react-router-dom';
import PreferencesContext from '../../contexts/preferences';
import LaunchGame from "./LaunchGame";

const Section = styled.section`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  color: ${props => props.theme.potential.text};
  background-color: ${props => props.theme.potential.backgroundColor};
  padding: 32px;
  box-sizing: border-box;
`;

const Container = styled.div`
  max-width: ${TABLET_WIDTH}px;
  text-align: center;
`;

const ImgWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;

  & > div {
    max-width: 840px;
    text-align: center;
  }
`;

const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
`;

const Potential = withRouter(({ history }) => {
  const { inGame } = useContext(PreferencesContext);

  return (
    <Section id="potential">
      <Container>
        <Header>
          <div>
            <h2>
              Your children deserve the chance to demonstrate their true
              mathematics potential
            </h2>
            <h5>
              Children and schools around the world have experienced math in a
              totally different way using BrainQuake. Come join them!
            </h5>
          </div>
        </Header>

        <ImgWrapper>
          <div>
            <img src={imgPotential} alt="" />
          </div>
        </ImgWrapper>

        {!inGame && <LaunchGame />}
      </Container>
    </Section>
  );
});

export default Potential;
